import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Logo from '../../../assest/images/logo.png';
import { Link ,useNavigate } from 'react-router-dom';
import { IoIosSearch  } from "react-icons/io";
import HeaderStyle from '../../Styles/Header.module.css';
import { FaEye, FaEyeSlash  } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { login, getSearchApi } from "../../../services/routes.services";
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { userlogin } from '../../../store/authSlice';
import { userlogout } from '../../../store/authSlice';
import LoginPopup from "../Login/UserLogin";
import constants from '../../../services/constants'

const Header =()=>{

    const [loginShow, setLoginShow] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [wondowlScroll, setWindowScroll] = useState(false);
    const [showMenu, setShowMeu] = useState(false);
    const [search, setSearch] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [keyWord, setKeyword] = useState('');
    const { isAuthenticated, user, token } = useSelector((state) => state.auth);
    
    const searchHandler= async ()=>{
        try{
            const response = await getSearchApi(keyWord)
            navigate('/search', { state: { keyWord, result: response.data }});
        }catch(error){
            console.error('error search result', error)
        }
    }

    const ToggleMenuHandler=()=>{
        setShowMeu(true)
    }
    const CloseMenuHandler=()=>{
        setShowMeu(false)
    }

    const openSearchHandler=()=>{
        setSearch(true)
    }
    const closeSearchHandler=()=>{
        setSearch(false)
    }

    useEffect(()=>{
        window.addEventListener("scroll", ()=>{
            setWindowScroll(window.scrollY > 300);
        })
    }, []);

    const loginShowHandler = ()=>{
        setLoginShow(true)
    }
    const loginCloseHandler = ()=>{
        setLoginShow(false)
        setShowPassword(false)
    }
    const handleLogout = () => {
        // Remove token from local storage
        localStorage.removeItem('token');
        localStorage.removeItem('userDetail');
        dispatch(userlogout());
        // Redirect to home or login page
        navigate('/');
    };

    const smoothScroll = () => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      };

    return(
        <header className={wondowlScroll ? HeaderStyle.fixHeader : null}>
            <Container>
                <Row>
                    <Col md={3}>
                        <div className={HeaderStyle.logo}>
                            <Link onClick={smoothScroll} to=''><img src={Logo} /> </Link>
                        </div>
                    </Col>
                    <Col md={9}>
                        <button type="button" onClick={ToggleMenuHandler} className={HeaderStyle.toggleMenu}><span></span></button>
                        <div className={showMenu ?  HeaderStyle.mobMenu + ' ' + HeaderStyle.active : HeaderStyle.mobMenu}>
                            <button type="button" onClick={CloseMenuHandler} className={HeaderStyle.closeMenu}><IoMdClose /></button>
                            <div className={HeaderStyle.headTop}>
                                {!isAuthenticated ?
                                    <button type="button" onClick={loginShowHandler}  className={HeaderStyle.whiteBtn + ' ' + HeaderStyle.loginBtn}>Login</button>
                                : 
                                    <div className={HeaderStyle.userLogin}>
                                        <figure>
                                            <img src={user.image!==null ? constants.IMAGE_BASE_URL+'alumni/'+user.image:(require('../../../assest/images/list-img01.png'))} />
                                        </figure>
                                        <div className={HeaderStyle.userDetail}>
                                        {user && <h6>{user.name}</h6>}
                                            <ul>
                                                <li><Link to='/dashboard'>My Dashboard</Link></li>
                                                <li><Link to='/' onClick={handleLogout}>Logout</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                }
                                {!isAuthenticated ? <Link to="/registration" className={HeaderStyle.whiteBtn}>REGISTER NOW</Link> : null }
                                {!isAuthenticated ?
                                    <>
                                        <button type="button" onClick={loginShowHandler} className={HeaderStyle.greenBtn}>BECOME A MEMBER</button>
                                        <button type="button" onClick={loginShowHandler} className={HeaderStyle.greenBtn}>DONATE</button>
                                    </>
                                    :
                                    <>
                                        <Link to="/membership" className={HeaderStyle.greenBtn}>BECOME A MEMBER</Link>
                                        <Link to="/donate" className={HeaderStyle.greenBtn}>DONATE</Link>
                                    </>
                                }
                            </div>
                            <nav className={HeaderStyle.navBar}>
                                <ul>
                                    <li><Link onClick={smoothScroll} to="/community">Community</Link></li>
                                    <li><Link onClick={smoothScroll} to="/events">Events</Link></li>
                                    <li><Link onClick={smoothScroll} to="/news">News</Link></li>
                                    <li><Link onClick={smoothScroll} to="/offers">Offers</Link></li>
                                    <li><Link onClick={smoothScroll} to="/about-MAAD">About MAAD</Link></li>
                                    <li><Link onClick={smoothScroll} to="/about-mayo">About Mayo</Link></li>
                                    <li><Link onClick={smoothScroll} to="/contact">Contact Us</Link></li>
                                    <li className={HeaderStyle.searchBox}>
                                        {!search ? 
                                            <button type="button" onClick={openSearchHandler}><IoIosSearch  className={HeaderStyle.searchIcon} /></button>
                                            :
                                            <button type="button" onClick={closeSearchHandler}><IoMdClose  className={HeaderStyle.searchIcon} /></button>
                                        }
                                        {search &&
                                        <div className={HeaderStyle.headSearch}>
                                            <input type="text" placeholder="Search" value={keyWord} onChange={(e) => setKeyword(e.target.value)} onKeyDown={(e)=>{ if(e.key === 'Enter'){searchHandler();}}}   />
                                            <button type="button" onClick={searchHandler} className={HeaderStyle.searchBtn}><IoIosSearch  className={HeaderStyle.searchIcon} /></button>
                                        </div>
                                        }
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </Col>
                </Row>
            </Container>
           {loginShow && <LoginPopup onClose={loginCloseHandler} />}
           <div className={showMenu ? HeaderStyle.overViewActive : null }></div>
        </header>
    )
}

export default Header;